import React from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { Col, Row, Card, Form, Button } from '@themesberg/react-bootstrap';
import axios from "axios";
import { API_URL, END_POINT_SUB_INDUSTRIES } from "../const";
import { useNavigate, Link } from 'react-router-dom';
import { showErrorToast, showSuccessToast } from "../utils/toast";

export const CreateSubIndustryForm = () => {

    const navigate = useNavigate();
    const rawToken = sessionStorage.getItem('quotetoken');
    const token = rawToken?.replace(/^"|"$/g, '');

  const formik = useFormik({
    initialValues: {
      name: "",
    },
    validationSchema: Yup.object({
      name: Yup.string().required("Sub Industry Name is required"),
    }),
    onSubmit: async (values, { setSubmitting }) => {
      try {

        setSubmitting(true);

        const response = await axios.post(API_URL + END_POINT_SUB_INDUSTRIES, values,
            {
                headers: {
                    // 'Content-Type': 'multipart/form-data',
                    'Accept': 'application/json',
                    Authorization: `Bearer ${token}`,
                }
            }
        );
        showSuccessToast(response.data.message)
        navigate('/industries');
      } catch (error) {
        showErrorToast(error.response?.data?.message || 'Failed to create Sub-Industry.')
      }finally {
        setSubmitting(false);
      }
    }
  });


  return (
    <Card border="light" className="bg-white shadow-sm mb-4">
      <Card.Body>
        <div className="d-flex justify-content-between align-items-center mb-4"> 
            <h5 className="mb-0">Add Sub Industry</h5> 
            <Link to="/sub-industries" className="text-decoration-none"> 
                Back to Listing 
            </Link> 
        </div>
        <Form noValidate onSubmit={formik.handleSubmit}>
          <Row>
            <Col md={6} className="mb-3">
              <Form.Group controlId="name">
                <Form.Label>Sub Industry Name</Form.Label>
                <Form.Control
                  type="text"
                  {...formik.getFieldProps("name")}
                  isInvalid={formik.touched.name && formik.errors.name}
                />
                <Form.Control.Feedback type="invalid">
                  {formik.errors.name}
                </Form.Control.Feedback>
              </Form.Group>
            </Col>

            {/* <Col sm={6} className="mb-3">
              <Form.Group controlId="address">
                <Form.Label>Company Address</Form.Label>
                <Form.Control
                  type="text"
                  {...formik.getFieldProps("address")}
                  isInvalid={formik.touched.address && formik.errors.address}
                />
                <Form.Control.Feedback type="invalid">
                  {formik.errors.address}
                </Form.Control.Feedback>
              </Form.Group>
            </Col> */}
          </Row>

          <div className="mt-3">
            <Button 
              variant="primary" 
              type="submit"
              disabled={formik.isSubmitting}
            >
              Save
            </Button>
          </div>
        </Form>
      </Card.Body>
    </Card>
  );
};